import { Pagination } from '../../../../../../models/pagination-table.model';
import { Transport } from '../../../../../../models/transport.model';
import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, inject, Input, Output, ViewChild } from '@angular/core';
import { PATHS } from '../../../../../../models/bary-paths.model';
import { Router, RouterLink } from '@angular/router';
import dayjs from 'dayjs';
import { AlertService } from '../../../../../../services/alert.service';
import { QuotationView } from '../../../../../../models/quotation-view.model';
import { TableOptions } from '../../../../../../services/i-bary-table-fetch-service';
import { BaryModalService } from '../../../../../../services/bary-modal.service';
import { CurrentDataService } from '../../../../../../services/current-data-service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { QuotationService } from '../../../../../../services/quotation.service';
import { QuotationStatusEnum } from '../../../../../../models/enums/quotation-status.enum';
import { CtaAction } from '../../../../../../models/cta.action';
import { LIST_ACTIONS } from '../../../../../../models/enums/action-cta.enum';
import { ISalesSupportActions } from '../../../../../../models/sales-support-actions.model';
import { MDBBootstrapModulesPro } from 'ng-uikit-pro-standard';
import { CommonModule } from '@angular/common';
import { TranslateDirective } from '../../../../../../directives/translate.directive';
import { SortDirective } from '../../../../../../directives/sort.directive';
import { SortByDirective } from '../../../../../../directives/sort-by.directive';
import { MeasureUnitPipe } from '../../../../../pipes/measure-unit.pipe';
import { BaryCtaComponent } from '../../../../components/bary-cta/bary-cta.component';
import { BaryBadgeComponent } from '../../../../components/bary-badge/bary-badge.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CountryNamePipeStandalone } from '../../../../../pipes/country-name.pipe';

@Component({
  selector: 'jhi-quotations-list',
  templateUrl: './quotations-list.component.html',
  standalone: true,
  imports: [
    MDBBootstrapModulesPro,
    TranslateDirective,
    SortDirective,
    SortByDirective,
    CommonModule,
    RouterLink,
    MeasureUnitPipe,
    TranslateModule,
    BaryCtaComponent,
    BaryBadgeComponent,
    FontAwesomeModule,
    CountryNamePipeStandalone,
  ],
  styleUrls: ['./quotations-list.component.scss'],
})
export class QuotationsListComponent implements AfterViewInit {
  private readonly modalService = inject(BaryModalService);
  private readonly jhiAlertService = inject(AlertService);
  private readonly currentDataService = inject(CurrentDataService);
  private readonly translateService = inject(TranslateService);
  private readonly router = inject(Router);
  private readonly quotationService = inject(QuotationService);

  @ViewChild('headers') headers!: ElementRef<HTMLTableRowElement>;

  @Input() transports: QuotationView[] = [];
  @Input() tableOptions?: TableOptions;
  @Input() pagination!: Pagination;

  @Output() paginationChange = new EventEmitter<Pagination>();

  protected readonly PATHS = PATHS;

  cols?: number;

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.updateColsNumber();
    }, 100);
  }

  @HostListener('window:resize')
  updateColsNumber(): void {
    const array = Array.from(this.headers.nativeElement.cells).filter(cell => cell.offsetWidth > 0);
    this.cols = array.length;
  }

  isPriceVisible(): boolean {
    return ['OLD', 'ONGOING'].includes(this.tableOptions!.state!);
  }

  trackId(index: number, item: QuotationView): number {
    return item.id!;
  }

  transition(): void {
    this.paginationChange.emit(this.pagination);
  }

  openRespondModal(transport: QuotationView): void {
    // Si moderator
    if (this.tableOptions?.isModerator) {
      this.modalService
        .openTransporterQuotationRespond(transport)
        .action()
        .subscribe(result1 => {
          this.currentDataService.getCustomer().subscribe(() => {
            if (result1.submit) {
              this.quotationService.acceptQuotation(transport).subscribe(
                () => {
                  const message = this.translateService.instant('baryApp.quotations.confirmModal.transporterContent');
                  this.modalService.openSuccess(message);
                  this.transition();
                },
                () => {
                  const message = this.translateService.instant('baryApp.quotations.errorModal.content');
                  this.modalService.openError(message);
                }
              );
            } else if (result1.second) {
              this.modalService
                .openTransporterQuotationCanceledConfirmation()
                .action()
                .subscribe(result2 => {
                  this.currentDataService.getCustomer().subscribe(() => {
                    if (result2.submit) {
                      transport.quotationRejectionMessage = result2.value.quotationRejectionMessage;
                      this.quotationService.denyQuotation(transport).subscribe(
                        () => {
                          const message = this.translateService.instant('baryApp.quotations.confirmModal.refusedContent');
                          this.modalService.openSuccess(message);
                          this.transition();
                        },
                        () => {
                          const message = this.translateService.instant('baryApp.quotations.errorModal.content');
                          this.modalService.openError(message);
                        }
                      );
                    }
                  });
                });
            }
          });
        });
    } else {
      // Si customer
      this.modalService
        .openCustomerQuotationRespond(transport)
        .action()
        .subscribe(result => {
          if (result.submit) {
            this.currentDataService.getCustomer().subscribe(
              customer => {
                if (customer !== undefined) {
                  this.quotationService.acceptQuotation(transport).subscribe(
                    () => {
                      const message = this.translateService.instant('baryApp.quotations.confirmModal.customerContent');
                      const buttons = {
                        first: 'Poursuivre',
                        second: undefined,
                      };
                      this.modalService
                        .openSuccess(message, buttons)
                        .action()
                        .subscribe(() => {
                          this.router.navigate([PATHS.ORDER_BASKET.path]).then();
                        });
                      this.transition();
                    },
                    () => {
                      const message = this.translateService.instant('baryApp.quotations.errorModal.content');
                      this.modalService.openError(message);
                    }
                  );
                } else {
                  const message = this.translateService.instant('baryApp.quotations.errorModal.content');
                  this.modalService.openError(message);
                }
              },
              () => {
                const message = this.translateService.instant('baryApp.quotations.errorModal.content');
                this.modalService.openError(message);
              }
            );
          } else if (result.second) {
            this.currentDataService.getCustomer().subscribe(
              customer => {
                if (customer !== undefined) {
                  this.quotationService.denyQuotation(transport).subscribe(
                    () => {
                      const message = this.translateService.instant('baryApp.quotations.confirmModal.refusedContent');
                      this.modalService.openSuccess(message);
                      this.transition();
                    },
                    () => {
                      const message = this.translateService.instant('baryApp.quotations.errorModal.content');
                      this.modalService.openError(message);
                    }
                  );
                } else {
                  const message = this.translateService.instant('baryApp.quotations.errorModal.content');
                  this.modalService.openError(message);
                }
              },
              () => {
                const message = this.translateService.instant('baryApp.quotations.errorModal.content');
                this.modalService.openError(message);
              }
            );
          }
        });
    }
  }

  isOld(): boolean {
    return this.tableOptions!.state === 'OLD';
  }

  isPayed(quotationStatus: QuotationStatusEnum | null | undefined): boolean {
    return quotationStatus === QuotationStatusEnum.FINALIZED;
  }

  resetTransport(transport: Transport): void {
    this.quotationService.resetQuotation(transport).subscribe(
      () => {
        const message = this.translateService.instant('baryApp.quotations.confirmModal.resetContent');
        const buttons = {
          first: this.translateService.instant('baryApp.quotations.confirmModal.new'),
          second: this.translateService.instant('baryApp.quotations.confirmModal.stay'),
        };
        this.modalService
          .openSuccess(message, buttons)
          .action()
          .subscribe(res => {
            if (res.first) {
              this.router.navigate([PATHS.MIDDLE_QUOTATIONS_NEW.path]).then();
            }
          });
        this.transition();
      },
      () => {
        const message = this.translateService.instant('baryApp.quotations.errorModal.content');
        this.modalService.openError(message);
      }
    );
  }

  totalUM(transport: Transport): number {
    return (transport.totalPallets ?? 0) + (transport.totalParcel ?? 0) + (transport.totalOtherUM ?? 0);
  }

  getTotalUMTooltip(transport: Transport): string {
    let result = '';
    if (transport.totalPallets) {
      result += transport.totalPallets + ' Palette(s)';
    }
    if (transport.totalParcel) {
      if (result.length > 0) {
        result += ', ';
      }
      result += transport.totalParcel + ' Colis';
    }
    if (transport.totalOtherUM) {
      if (result.length > 0) {
        result += ', ';
      }
      result += transport.totalOtherUM + ' UM(s)';
    }
    return result;
  }

  calculatePriceTTCFromPriceHT(quotationPriceHT: number): number {
    return quotationPriceHT * 1.2;
  }

  isNotFinalized(quotationStatus?: QuotationStatusEnum | null): boolean {
    return !this.isPayed(quotationStatus);
  }

  public getCta(quotationView: QuotationView): CtaAction[] {
    const ctaActions = [];
    if ((this.tableOptions?.state !== 'ONGOING' && !this.tableOptions?.isModerator) || (this.tableOptions.state !== 'NEW' && this.tableOptions?.isModerator)) {
      ctaActions.push({
        label: this.translateService.instant('unvalidatedBaskets.modal.actions.detail'),
        action: LIST_ACTIONS.DETAIL_TRANSPORT,
        disabled: false,
        dataIdCypress: `details-transport-${quotationView.id}`,
      });
    }

    if (this.tableOptions?.state === 'ONGOING' && !this.tableOptions?.isModerator) {
      ctaActions.push({
        label: this.translateService.instant('unvalidatedBaskets.modal.actions.respond'),
        action: LIST_ACTIONS.DETAIL_TRANSPORT,
        disabled: false,
        dataIdCypress: `details-transport-${quotationView.id}`,
      });
    }

    if (this.tableOptions?.state === 'NEW' && this.tableOptions?.isModerator) {
      ctaActions.push({
        label: this.translateService.instant('unvalidatedBaskets.modal.actions.demand'),
        action: LIST_ACTIONS.DETAIL_TRANSPORT,
        disabled: false,
        dataIdCypress: `details-transport-${quotationView.id}`,
      });
    }

    if (this.tableOptions?.state !== 'NEW' && this.tableOptions?.isModerator) {
      ctaActions.push({
        label: this.translateService.instant('unvalidatedBaskets.modal.actions.contactCustomer'),
        action: LIST_ACTIONS.SHOW_POPIN_CONTACT,
        disabled: !quotationView.user,
      });
    }

    if (this.isOld() && this.isNotFinalized(quotationView?.quotationStatus) && this.tableOptions?.isModerator) {
      ctaActions.push({
        label: this.translateService.instant('baryApp.quotations.action.reset'),
        action: LIST_ACTIONS.RESET_TRANSPORT,
      });
    }

    return ctaActions;
  }

  public onSelectAction(cta: CtaAction, quotationView: QuotationView): void {
    if (cta.action === LIST_ACTIONS.RESET_TRANSPORT) {
      this.resetTransport(quotationView);
    }
    if (cta.action === LIST_ACTIONS.DETAIL_TRANSPORT) {
      if ((this.tableOptions!.state === 'NEW' && !!this.tableOptions?.isModerator) || (this.tableOptions!.state === 'ONGOING' && !this.tableOptions?.isModerator)) {
        this.openRespondModal(quotationView);
        return;
      }

      if (quotationView.pickupDate) {
        quotationView.pickupDate = dayjs(quotationView.pickupDate);
      }
      if (quotationView.deliveryDate) {
        quotationView.deliveryDate = dayjs(quotationView.deliveryDate);
      }
      this.modalService
        .showDetailTransport(quotationView)
        .action()
        .subscribe({
          error: () => {
            this.jhiAlertService.addNotification({
              type: 'danger',
              message: this.translateService.instant('unvalidatedBaskets.error.contacter'),
            });
          },
        });
    }

    if (cta.action === LIST_ACTIONS.SHOW_POPIN_CONTACT) {
      this.modalService
        .showPopinContact(quotationView)
        .action()
        .subscribe({
          next: data => {
            if (data.submit) {
              this.jhiAlertService.addNotification({
                type: 'success',
                message: this.translateService.instant('unvalidatedBaskets.success.contacter'),
              });
              this.transition();
            }
          },
          error: () => {
            this.jhiAlertService.addNotification({
              type: 'danger',
              message: this.translateService.instant('unvalidatedBaskets.error.contacter'),
            });
          },
        });
    }
  }

  public getObjectFromJson(json: any): { date: string; commercialId: string; commercialFullName: string } {
    return JSON.parse(json) as {
      date: string;
      commercialId: string;
      commercialFullName: string;
    };
  }

  public displayMoreEvent(salesSupportActionsList: ISalesSupportActions[]): void {
    const messages: string[] = salesSupportActionsList.map(
      val =>
        this.translateService.instant('unvalidatedBaskets.error.' + val.typeSalesSupportActionsEnum, {
          date: this.getObjectFromJson(val.value).date,
          commercialFullName: this.getObjectFromJson(val.value).commercialFullName,
        }) as string
    );
    this.modalService.showPopinEvtOnTransport(messages).action().subscribe();
  }
}
